import React from 'react'
import Page from './components/Page'


export const App = () => {
  return (
    <section>
      <Page />
    </section>
  )
}
